module.exports = __webpack_public_path__ + "MaterialIcons-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons-iconfont/dist/fonts/MaterialIcons-Regular.woff2
// module id = 83
// module chunks = 0